module.exports = __webpack_public_path__ + "img/g6.0e410e40.jpg";